export function vsFromNumber(number: string): string {
  return number.replace(/\D/g, "");
}
